// @ts-nocheck
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'

export const InfluencerProtected = ({
  component: Component,
  user,
  ...rest
}) => <Component user={user} {...rest} />
